import { Component, Vue } from 'vue-property-decorator';
import ChatWindow from 'vue-advanced-chat';
import ChatModule from '@/store/modules/chat-module';
import 'vue-advanced-chat/dist/vue-advanced-chat.css';
import {  itiSignalRService, i18n } from '@/iti-core-vue';
import { Room } from '@/shared/dtos/room';
import { Message } from '@/shared/dtos/message';
import { defaultThemeStyles } from'@/shared/themes/chat.ts' ;
import '@/../public/assets/css/chat.css';

@Component({
    components: {
        ChatWindow
    },
})
export default class ChatMultiSala extends Vue {
      
    public get rooms() : Room[]{
      return ChatModule.rooms;
    }
    public set rooms(rooms: Room[]){
      ChatModule.context.commit("setRooms", rooms);
    }
    public get messages(): Message[]{
      return ChatModule.messages;
    }
    //When true, scrolling down while on the rooms menu left of the chat launches an event to fetch more rooms. False deactivates it and the event won't be launched (this is a bit wonky)
    public get roomsLoaded(){
        return ChatModule.roomsLoaded;
    }
    //When true, a spinner is shown inside the rooms menu, false deactivates it
    public loadingRooms: boolean = false;
    
    //When false, a spinner is shown inside the chat, true deactivates it and prevents launching further events to request more messages when scrolling up in the chat
    public get messagesLoaded(){
        return ChatModule.messagesLoaded;
    }
    //Controls how a message appears in the chat: If it has the same user id as this one the message will appear to the right and colored green
    public get currentUserId() {
        return ChatModule.myId;
    }
    //Prop to change the language of various chat texts
    public get textMessages() {
        return {
            ROOMS_EMPTY: i18n.tc('chat.ROOMS_EMPTY'),
            ROOM_EMPTY: i18n.tc('chat.ROOM_EMPTY'),
            NEW_MESSAGES: i18n.tc('chat.NEW_MESSAGES'),
            MESSAGE_DELETED: i18n.tc('chat.MESSAGE_DELETED'),
            MESSAGES_EMPTY: i18n.tc('chat.MESSAGES_EMPTY'),
            CONVERSATION_STARTED: i18n.tc('chat.CONVERSATION_STARTED'),
            TYPE_MESSAGE: i18n.tc('chat.TYPE_MESSAGE'),
            SEARCH: i18n.tc('chat.SEARCH'),
            IS_ONLINE: i18n.tc('chat.IS_ONLINE'),
            LAST_SEEN: i18n.tc('chat.LAST_SEEN'),
            IS_TYPING: i18n.tc('chat.IS_TYPING')
        }
      }
    
    public get styles(){
        return defaultThemeStyles;
    }

    currentRoomId: number = -1;
    
    public async created() {
        await ChatModule.fetchId().then(() => {
            this.loadFirstRooms();
            itiSignalRService.listenFor('receiveMessage',this.handleMessage);
            itiSignalRService.listenFor('messageRead',this.handleMessageRead);
        });
        
    }
    //Stop listening for the event when we exit the view
    public destroyed(){
        itiSignalRService.unListenFor('receiveMessage');
        itiSignalRService.unListenFor('messageRead');
    }
    public async loadFirstRooms(){
        this.loadingRooms = true;
        //load first X rooms with pagination. Currently we just load all rooms as the number of rooms per user is very low
        await ChatModule.loadRooms().then(() => {
          this.loadingRooms = false;
        });
        
    }
    public async handleMessageRead(idMensaje: number){
        await ChatModule.messageRead(idMensaje);
    }
    public async handleMessage(mensaje: Message, roomId: number){
      const currentRoomId = this.currentRoomId;
        await ChatModule.receiveMessage( { mensaje, currentRoomId, roomId} );
    }
    //Makes messages behave correctly when changing rooms
    public resetMessages() {
        ChatModule.context.commit('setMessages',[]);
        ChatModule.updateMessagesLoaded(false);
    }

    public async fetchMessages({ room, options } : {room:any, options:any}) {
        //Called every time a user enters a room or when the user scrolls up inside the chat to load more messages
        //options.reset is true when the room is opened for the first time
        if(options && options.reset){
            this.resetMessages();
            await ChatModule.fetchInitialRoomMessages(room.roomId);
        }
        else{
            await ChatModule.fetchMoreRoomMessages(room.roomId);
        }
        //we need to know the current room's id to properly receive new messages from the server
        this.currentRoomId = room.roomId;
        /*
        if(this.currentRoomId != room.roomId){
            this.currentRoomId = room.roomId;
        }
        else{
            this.currentRoomId = room.roomId;
        }*/
    } 
    public sendMessage ({ roomId, content, file, replyMessage } : {roomId:any, content:any, file:any, replyMessage:any}) { 
        //Called every time a user presses enter while writing or clicks on the send icon
        //Send message to server, server will return the new message to us and every other user in the room
        ChatModule.sendMessage({content, roomId});
    } 

    
    public async fetchMoreRooms() {
            this.loadingRooms = true;
            //Load more rooms. Currently we don't use pagination for rooms so this method is useless, but is called by the component
            this.loadingRooms = false;
            /*await ChatModule.pedirMasSalas().then(() =>{
                this.loadingRooms = false;
            });*/
        
    }
}
